<template>
    <form
        class="login-form"
        id="login-form"
        action="POST"
        @submit.prevent="handleRegisterForm()"
    >
        <div class="login-form__wrapper">
            <h2 class="login-form__heading">Zaloguj się</h2>
            <p class="login-form__text">
                Jeżeli w ciągu ostatniego roku byłaś/eś uczestnikiem konferencji
                organizowanych przez Med Space, to Twoje konto już istnieje -
                zaloguj się korzystając z niego.
            </p>

            <div class="login-form__input-wrapper">
                <form-input
                    label="E-mail"
                    v-model="email"
                    :modelValue="email"
                    type="email"
                    name="email"
                    icon="person"
                    placeholder="Wpisz adres e-mail"
                    :error-messages="errorMessage"
                ></form-input>
                <div>
                    <form-input
                        label="Hasło"
                        v-model="password"
                        :modelValue="password"
                        type="password"
                        name="password"
                        icon="lock"
                        placeholder="Wpisz hasło"
                        :error-messages="errorMessage"
                    ></form-input>
                    <a
                        href="/password/reset"
                        class="login-form__passwd-reminder reminder"
                        >Nie pamiętasz hasła?</a
                    >
                </div>
                <button class="login-form__login-button">Zaloguj się</button>
            </div>
            <div class="login-form__register">
                <p class="login-form__register-text">Nie posiadasz konta?</p>
                <a href="/rejestracja" class="login-form__register-button"
                    >Zarejestruj się &rarr;</a
                >
            </div>
        </div>
    </form>
</template>
<script>
import FormInput from "./formInput";

export default {
    components: {
        FormInput,
    },
    data() {
        return {
            email: "",
            password: "",
            remember: "",
            processing: "",
            errorMessage: null,
        };
    },

    methods: {
        handleRegisterForm() {
            axios
                .post("/api/login", {
                    email: this.email,
                    password: this.password,
                    remember: this.remember,
                })
                .then((response) => {})
                .then((response) => {
                    axios
                        .post("/api/user-has-access")
                        .then((response) => {
                            if (response.data.hasAccess) {
                                window.location.href = "/";
                            } else {
                                window.location.href = "/profil";
                            }
                        })
                        .catch((error) => {
                            this.errorMessage = error.response.data.errors;
                        });
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.errors;
                })
                .then((error) => {
                    // Niepotrzebnie scrolluje do samej góry strony
                    // window.scrollTo(
                    //     document.querySelector(".error").offsetTop,
                    //     0
                    // );
                });
        },
    },
};
</script>
